export default {
  'Difficulty level': 'ระดับความยาก',
  'Your bet': 'เดิมพัน',
  'Start game': 'เริ่ม​เล่น​เกมส์',
  'Take prize': 'เอา',
  'Try again': 'ลองอีกครั้ง',
  Bet: 'เดิมพัน',
  Profit: 'รายได้',
};
